/**
 * Official PostHog EU Cloud client config (web posthog-js + mobile RN).
 * Ingest host is eu.i.posthog.com; the dashboard stays at eu.posthog.com.
 */

export const POSTHOG_EU_INGEST_HOST = 'https://eu.i.posthog.com';

/** @type {'2026-05-30'} posthog-js `defaults` snapshot from the official EU snippet. */
export const POSTHOG_JS_DEFAULTS = '2026-05-30';
